import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { Edp, PromotionModel } from '@bytel/bytel-sales';
import { FundingMethod } from '@bytel/checkout';

import { ModalService } from '@base/common/services/modal.service';

import { MainCartService } from '@services/main-cart.service';

import { ModalComponent } from '@shared/modal/modal.component';

import { Observable, of } from 'rxjs';

import { DataCyDirective } from '../../../../../common/directives/data-cy.directive';

@Component({
    selector: 'checkout-modal-prices-compatibility',
    templateUrl: './modal-prices-compatibility.component.html',
    styleUrl: 'modal-prices-compatibility.component.scss',
    standalone: true,
    imports: [DataCyDirective, ReactiveFormsModule],
})
export class ModalPricesCompatibilityComponent extends ModalComponent {
    @Input() type: string;
    @Input('incompatibleProducts') products: { toAdd: any; toDelete: any };

    @Output() public valid = new EventEmitter<boolean>();
    public title = 'Incompatibilité sur les prix';
    public modalRef: ModalService;
    public isLoading: boolean = false;
    public actionsControl: FormControl<boolean | null> = new FormControl(null);
    public labelsKeep: string[];
    public labelsAdd: string[];

    private cartService: MainCartService = inject(MainCartService);

    public ngOnInit(): void {
        this.labelsAdd = this._getLabels(this.products.toAdd);
        this.labelsKeep = this._getLabels(this.products.toDelete);
    }

    public validate(): void {
        let obs: Observable<any> = of(null);
        if (this.actionsControl.value) {
            const toDelete = this.products.toDelete;
            switch (true) {
                case toDelete instanceof PromotionModel:
                    obs = this.cartService.removeCouponPromotion();
                    break;
                case toDelete instanceof Edp:
                    obs = this.cartService.removeProduct(toDelete as Edp);
                    break;

                case toDelete instanceof FundingMethod:
                    this.cartService.setFundingMethod(null).subscribe();
                    break;
            }
        }

        obs.subscribe(() => {
            this.valid.emit(this.actionsControl.value);
            this.isLoading = false;
            this.modalRef.close();
        });
    }

    private _getLabels(elm: PromotionModel | Edp | FundingMethod): string[] {
        let labels: string[] = ['', ''];
        switch (true) {
            case elm instanceof Edp:
                labels = ["l'étalement de paiement", 'Etalement de paiement'];
                break;
            case elm instanceof FundingMethod:
                labels = ['la facilité de paiement', 'Facilité de paiement'];
                break;
            case elm instanceof PromotionModel:
                labels = ['le code promo', 'Code Promo'];
                break;
        }
        return labels;
    }
}
